var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0087 28.2829C24.2531 28.4595 24.5677 28.5033 24.8485 28.3958C25.128 28.2869 25.3347 28.0413 25.3971 27.7439C26.0563 24.5812 27.6554 16.575 28.2547 13.6991C28.3002 13.4813 28.2248 13.2556 28.0584 13.1109C27.8907 12.9662 27.6593 12.925 27.4538 13.002C24.2739 14.205 14.4804 17.9571 10.4775 19.4694C10.224 19.5663 10.0589 19.8146 10.0667 20.0895C10.0758 20.363 10.2565 20.6006 10.5165 20.6803C12.3119 21.2287 14.6676 21.9921 14.6676 21.9921C14.6676 21.9921 15.7688 25.3885 16.3421 27.1145C16.4149 27.3323 16.5813 27.5022 16.7997 27.5606C17.0195 27.6191 17.2522 27.558 17.416 27.4C18.3377 26.5117 19.7626 25.1375 19.7626 25.1375C19.7626 25.1375 22.472 27.165 24.0087 28.2829ZM15.6583 21.5619L16.9324 25.8518L17.2158 23.1353C17.2158 23.1353 22.1339 18.6037 24.9395 16.0213C25.0214 15.9456 25.0318 15.8182 24.9642 15.7292C24.8966 15.6402 24.7718 15.619 24.6795 15.6801C21.4293 17.7991 15.6583 21.5619 15.6583 21.5619Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramWhite);
export default __webpack_public_path__ + "static/media/telegram-white.267abaf162a73683ff1371f807d96f51.svg";
export { ForwardRef as ReactComponent };